<template>
  <div class="container box-login">
    <img src="@/assets/images/logoLogin.png" class="logo" alt="" srcset="" />
    <h6 class="center-align" style="color: #BCBCBC">
      Insira seu email para recuperar sua conta
    </h6>
    <div class="title-divider" />
    <form @submit.prevent="forgetPassword" style="max-width: 400px">
      <div class="row">
        <div class="input-field col s12">
          <label for="email">Email</label>
          <input
            type="text"
            v-model="form.email"
            name="email"
            id="email"
            v-validate="'required|email'"
            :class="{ invalid: errors.first('email') }"
          />
          <span class="helper-text" :data-error="errors.first('email')"></span>
        </div>
      </div>

      <div class="actions">
        <a
          class="waves-effect btn-large flat"
          @click="$router.push('/login')"
          v-show="!load"
          >Voltar</a
        >
        <button
          class="waves-effect waves-light btn-large"
          type="submit"
          :class="{ load: load }"
        >
          <feather v-if="load" type="loader" animation="spin" />
          <template v-else
            >Enviar</template
          >
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "forgetPassword",
  data: () => ({
    load: false,
    form: {
      email: ""
    }
  }),
  methods: {
    async forgetPassword() {
      await this.$validator.validateAll();
      if (!this.errors.items.length > 0) {
        this.load = true;
        try {
          await this.$http.post("auth/forgot", { email: this.form.email });
          M.toast({
            html: `Foi enviado um email para ${this.form.email} com o link de recuperação de senha.`,
            displayLength: 3000
          });
          document.querySelector(".toast").classList.add("success");
          this.$router.push("/login");
        } catch (e) {
          M.toast({
            html:
              "Error ao enviar email, por favor verificar o email digitado ou tentar novamente mais tarde.",
            displayLength: 3000
          });
        }
        this.load = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables.scss";

.title-divider {
  height: 50px;
}

.box-login {
  max-width: 450px;
  display: flex;
  flex-direction: column;
  .logo {
    align-self: center;
    margin-bottom: 24px;
  }
  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
    button,
    a {
      width: 35vh;
    }

    button {
      margin-left: 10px;
    }
  }

  @media #{$small-and-down} {
    .actions {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column-reverse;
      button,
      a {
        width: 100%;
      }
      button {
        margin-bottom: 20px;
        margin-left: 0;
      }
    }
  }
}
</style>
